<div class="modal-header">
  <h4 class="modal-title">
    Select Question Type
  </h4>
</div>
<div class="modal-body">

  <div class="inner-modal-body">
    <div class="__actions gs keep-lay">
      <div class="lay">
        <div class="option-item" *ngFor="let option of questionTypes"
          (click)="selectOption(option)">
          {{ option?.questionTypeName }}
        </div>
      </div>
    </div>
  </div>
</div>